/**
 * Módulo Documentos.
 * @module Documentos
 * @see Documentos
 */

import React, { useRef, useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Tree } from "react-arborist";
import { useFirebase } from "app/firebase/context";
import {
  SearchArray,
  flattenRoutes,
  extractPaths,
  transformPaths,
} from "app/components/helpers/Various";
import { FaFolderMinus } from "react-icons/fa";
import { Dialogo } from "app/components/helpers/Dialogo";
import { get, set, push, update, remove, onValue } from "firebase/database";
import { IoInformationCircleOutline } from "react-icons/io5";
import BackButton from "app/components/helpers/BackButton";
import Switch from "react-switch";
import {
  ref,
  getDownloadURL,
  deleteObject,
  getStorage,
  uploadBytes,
  uploadString,
  listAll,
  copyTo,
  updateMetadata,
  getMetadata,
} from "firebase/storage";
import {
  getSupportedFileTypes,
  getUploadLimits,
  truncarCadena,
  handleDescargar,
} from "./funcionesDocs";
import { safeReplace } from "app/utils/utils";
import { getTituloJunta } from "app/views/juntas/FuncionesJuntas";
import Tooltip from "react-tooltip-lite";
import obtenerIconoPorExtension from "app/components/helpers/IconosFicheros";
import Node from "./Node";
import { useStore } from "react-redux";
import { getFunctions, httpsCallable } from "firebase/functions";
import getCustomToastOptions from "app/components/helpers/getCustomToastOptions";
import { toast } from "react-toastify";
import { findNodeById, renameNodeById } from "app/components/helpers/Various";
import Emulador from "app/components/EmuladorApp/Emulador";
import ModalComponent from "app/components/ModalComponent/ModalComponent";
import FormularioEnvioAvisos from "app/components/ModalComponent/FormularioEnvioAvisos";
import { FaFolderPlus } from "react-icons/fa";
import ClipLoader from "react-spinners/ClipLoader";
import { TextField } from "@mui/material";
import { LuFolderEdit } from "react-icons/lu";
import { MultiSelect } from "react-multi-select-component";

const Documentos = () => {
  const [archivoAvisos, setArchivoAvisos] = useState("");
  const [pathAvisos, setPathAvisos] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogModificar, setShowDialogModificar] = useState(false);
  const [showDialogSubida, setShowDialogSubida] = useState(false);
  const [nombreCarpetaModificar, setNombreCarpetaModificar] = useState("");
  const [pathCarpetaModificar, setPathCarpetaModificar] = useState("");
  const [esGeneral, setEsGeneral] = useState(false);
  let { IdComu, Identificador, docusUsuario, IdJunta } = useParams();

  const nombreDocumentacionGeneral = "10 Documentación general";
  const nombreJuntasPropietarios = "Juntas de Propietarios";

  Identificador =
    Identificador === "documentaciongeneral" ? nombreDocumentacionGeneral : Identificador;

  const store = useStore();
  const lengu = store.getState().lenguajes;
  const diccionario = lengu.diccionario;
  const firebase = useFirebase();
  const [archivosEnCarpetaArborist, setArchivosEnCarpetaArborist] = useState({
    carpeta: "",
    archivos: [],
    path: "",
  });
  const deshabilitadoRef = useRef(null);
  const [datosIniciales, setDatosIniciales] = useState({
    nombreInicial: "",
    transferibleInicial: false,
  });
  const [deshabilidato, setDeshabilidato] = useState(true);
  const [gData, setGData] = useState([]);
  const [inputValue, setInputValue] = useState(nombreCarpetaModificar.split(".")[0]);
  const horaActual = new Date().toLocaleTimeString();
  const [loading, setLoading] = useState(true);
  const [checkedTransferible, setCheckedTransferible] = useState(false);
  const [term, setTerm] = useState("");
  const treeRef = useRef(null);
  const [mostrarInput, setMostrarInput] = useState(false);
  const [nombreCarpeta, setNombreCarpeta] = useState("");
  const functions = getFunctions(firebase.app, process.env.REACT_APP_FIREBASE_ZONE);
  const [seleccionNuevaCarpeta, setSeleccionNuevaCarpeta] = useState("");
  let [rolesOptions, setRolesOptions] = useState([]);
  const [soloPresi, setSoloPresi] = useState([]);
  const locationSelector = {
    allItemsAreSelected: "Todos los roles han sido seleccionados.",
    clearSearch: "Limpiar búsqueda",
    clearSelected: "Limpiar seleccionado",
    noOptions: "No hay roles",
    search: "Buscar",
    selectAll: "Seleccionar todos",
    selectAllFiltered: "Seleccionar todos (filtrado)",
    selectSomeItems: "Visible sólo para...",
    create: "Crear",
  };
  const [respuesta, setRespuesta] = useState(null); // Estado para almacenar la respuesta seleccionada
  const [showDialogForm, setshowDialogForm] = useState(false);
  const [refrescarSoloPresi, setRefrescarSoloPresi] = useState(false);

  const [estaArrastrandoEncima, setEstaArrastrandoEncima] = useState(false);

  const [checkHabilitar, setCheckHabilitar] = useState({
    transferible: false,
    nombreCambiar: "",
  });

  const [refrescar, setRefrescar] = useState(false);
  const [refrescarRoles, setRefrescarRoles] = useState(false);
  const [nombreComu, setNombreComu] = useState("");
  const [dialogoContenido, setDialogoContenido] = useState({
    titulo: "",
    cuerpo: "",
    ejecutarFuncion: "",
    path: "",
    inputElement: false,
    nombreCambiar: "",
  });
  const [usuario, setUsuario] = useState(null);
  let rootFolder = docusUsuario == "true" ? `usuarios/${Identificador}/` : Identificador;

  const [showModal, setShowModal] = useState(true);

  const [archivosTraferibles, setArchivosTraferibles] = useState([]);

  const [ObtenerSoloPresi, setObtenerSoloPresi] = useState([]); // Estado para almacenar la respuesta seleccionada

  const [rolesEnvios, setRolesEnvios] = useState([]);

  const fileTypes = getSupportedFileTypes();
  const uploadLimits = getUploadLimits();
  const maxArchivos = uploadLimits.maxArchivos;
  const maxFileSizeMB = uploadLimits.maxFileSizeMB;

  // Definimos el estado inicial como true
  const nombreEspecial =
    docusUsuario === "true"
      ? "Mi Carpeta"
      : Identificador !== "10 Documentación general"
      ? "Raíz"
      : diccionario.DocumentacionGeneral;

  /**
   * Abre el formulario de diálogo estableciendo el estado `showDialogForm` a `true`.
   *
   * Generalmente se utiliza para mostrar un modal o ventana emergente que permite
   * al usuario realizar alguna acción (como editar, crear, confirmar, etc.).
   *
   * @function abrirDiagolo
   * @returns {void}
   */
  const abrirDiagolo = () => {
    setshowDialogForm(true);
  };
  /**
   * Maneja el evento cuando un elemento arrastrado está encima del área de destino.
   *
   * Previene el comportamiento por defecto del navegador y actualiza el estado
   * para indicar que un archivo u objeto está siendo arrastrado encima del área.
   *
   * @function manejarArrastreEncima
   * @param {DragEvent} event - El evento de arrastre (`dragover`).
   * @returns {void}
   */
  const manejarArrastreEncima = (event) => {
    event.preventDefault();
    setEstaArrastrandoEncima(true);
  };
  /**
   * Maneja el evento cuando un elemento arrastrado sale del área de destino.
   *
   * Actualiza el estado para indicar que ya no hay un archivo u objeto
   * siendo arrastrado encima del área designada.
   *
   * @function manejarArrastreFuera
   * @returns {void}
   */
  const manejarArrastreFuera = () => {
    setEstaArrastrandoEncima(false);
  };

  /**
   * Fuerza una recarga o actualización del componente.
   *
   * Cambia el estado booleano `refrescar`, provocando un re-render en los efectos o componentes que dependen de este estado.
   *
   * @function refresh
   * @returns {void}
   */
  const refresh = () => {
    setRefrescar(!refrescar);
  };
  /**
   * Transforma una lista de elementos con estructura de árbol en un formato jerárquico organizado por carpetas.
   *
   * Esta función toma una lista de archivos y carpetas y los agrupa por su ruta padre, construyendo una estructura
   * organizada con listas de `files`, `folders` y `children` para cada carpeta detectada.
   *
   * @function transformData
   * @param {Array<Object>} data - Lista de elementos con propiedades como `id`, `isFile`, `name`, `children`, etc.
   * @returns {Array<Object>} Lista de objetos que representan nodos de carpeta, con su respectiva jerarquía y contenido.
   */
  function transformData(data) {
    let result = {};

    data.forEach((item) => {
      const pathParts = item.id.split("/");
      const parentPath = pathParts.slice(0, -1).join("/");

      if (!result[parentPath]) {
        result[parentPath] = {
          id: parentPath,
          name: parentPath.split("/").pop(),
          children: [],
          path: parentPath,
          files: [],
          folders: [],
        };
      }

      if (item.isFile) {
        // Si es un archivo, lo agregamos a "files" y "children"
        result[parentPath].files.push(item.id);
        result[parentPath].children.push(item.id);
        result[parentPath].folders.push(item); // También debe ir en folders
      } else {
        // Si es una carpeta, la agregamos a "folders"
        result[parentPath].folders.push({
          id: item.id,
          name: item.name,
          children: item.children,
          path: item.path,
          files: item.files,
          folders: item.folders,
        });
      }
    });

    return Object.values(result);
  }
  /**
   * Carga los documentos desde el sistema de archivos de Firebase y los organiza
   * en una estructura que luego es usada para renderizar la vista de documentos.
   *
   * Dependiendo del estado del usuario, puede agregar la carpeta de "Documentación General"
   * a los elementos cargados si no está siendo visualizada desde la sección de documentación general.
   *
   * También actualiza el estado de la interfaz con los datos de los documentos y su estructura.
   *
   * @async
   * @function loadDocuments
   *
   * @throws {Error} Si ocurre un error durante la obtención de los documentos o durante el proceso de actualización de la interfaz.
   */
  const loadDocuments = async () => {
    try {
      let treeElements = await firebase.getFolderContents(rootFolder);
      // Añado la carpeta 10 Documentacion General si no estamos en la documentación general desde el despacho
      if (Identificador !== nombreDocumentacionGeneral && docusUsuario !== "true") {
        let docuGeneral = await firebase.getFolderContents(nombreDocumentacionGeneral);
        docuGeneral = transformData(docuGeneral);
        treeElements = treeElements.concat(docuGeneral);
      }
      /*
      treeElements.map(rama => {
        if(rama.id===nombreDocumentacionGeneral){
          rama.nameUPD = "Documentación general";
        }
      });
      */
      setGData(treeElements);

      const firstLevelElements = [];
      for (const node of treeElements) {
        firstLevelElements.push(node.name);
      }

      setArchivosEnCarpetaArborist({
        carpeta: Identificador + "/",
        archivos: firstLevelElements,
        path: rootFolder + "/",
        firstLevel: true,
      });

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  /**
   * Refresca el contenido de la carpeta actual.
   *
   * Llama a la función `loadDocuments` para volver a cargar los elementos de la carpeta,
   * asegurando que se muestren los archivos y carpetas más recientes.
   *
   * @async
   * @function refrescarCarpetaNueva
   * @returns {Promise<void>} Promesa que se resuelve una vez se ha completado la recarga de documentos.
   */
  const refrescarCarpetaNueva = async () => {
    // Llamada a la función al renderizar el componente
    await loadDocuments();
  };
  /**
   * Obtiene el nombre de una comunidad específica desde Firebase.
   *
   * Utiliza el `Identificador` como clave para acceder a la comunidad en la base de datos.
   * Si la comunidad existe, se actualiza el estado `setNombreComu` con el nombre obtenido.
   *
   * Maneja errores tanto en la obtención de datos como en la lectura del valor del snapshot.
   *
   * @async
   * @function obtenerNombreComunidad
   * @returns {Promise<void>} Promesa que se resuelve cuando se completa la operación de lectura.
   */
  const obtenerNombreComunidad = async () => {
    try {
      const snapshot = await get(firebase.getReferencia(`Comunidad/${Identificador}`, null));

      try {
        const nombreComu = snapshot.val();
        setNombreComu(nombreComu.Nombre);
        // Si necesitas más código aquí...
      } catch (error) {
        console.error("Ha ocurrido un error:", error);
      }
      //const aplanado = flattenRoutes(carpetas);
    } catch (error) {}
  };
  /**
   * Carga la estructura de carpetas específicas para el "SoloPresi" de una comunidad desde Firebase. SoloPresi sirve para guardar
   * los roles por carpeta
   *
   *
   * Esta función accede a la referencia `SoloPresi/{Identificador}` en la base de datos y extrae las carpetas
   * correspondientes. Además, si el `Identificador` actual no es la carpeta de documentación general,
   * también incluye la carpeta `SoloPresi/nombreDocumentacionGeneral`.
   *
   * Los datos obtenidos se almacenan en el estado `setSoloPresi`.
   *
   * @async
   * @function cargarSoloPresi
   * @returns {Promise<void>} Promesa que se resuelve al terminar de cargar y combinar los datos.
   */
  const cargarSoloPresi = async () => {
    try {
      const snapshot = await get(firebase.getReferencia(`SoloPresi/${Identificador}`, null));

      const carpetas = {};
      snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        carpetas[childKey] = childData;
      });

      //const aplanado = flattenRoutes(carpetas);

      // Añado la carpeta 10 Documentacion General si no estamos en la documentación general desde el despacho
      if (Identificador !== nombreDocumentacionGeneral) {
        const solopresigeneral = await get(
          firebase.getReferencia(`SoloPresi/${nombreDocumentacionGeneral}`, null)
        );

        const carpetasGeneral = {};

        solopresigeneral.forEach((childSnapshot) => {
          const childKey = childSnapshot.key;
          const childData = childSnapshot.val();
          carpetasGeneral[childKey] = childData;
        });

        if (Object.keys(carpetasGeneral).length > 0) {
          carpetas[nombreDocumentacionGeneral] = carpetasGeneral;
        }
      }

      setSoloPresi(carpetas);
    } catch (error) {}
  };
  /**
   * Cierra el diálogo de modificación.
   *
   * Esta función actualiza el estado `setShowDialogModificar` a `false`, ocultando así el formulario
   * o ventana de diálogo que permite modificar información.
   *
   * @function handleCloseModificar
   */
  const handleCloseModificar = () => {
    setShowDialogModificar(false);
  };
  /**
   * Carga los roles desde Firebase y los transforma en opciones para un selector.
   *
   * Esta función obtiene los datos de la ruta `Roles2` en la base de datos de Firebase,
   * los transforma en objetos con `label` y `value` para su uso en un componente select,
   * y actualiza el estado `rolesOptions` con los resultados.
   *
   * @async
   * @function cargarRoles
   * @returns {Promise<void>}
   */
  const cargarRoles = async () => {
    try {
      const snapshot = await get(firebase.getReferencia("Roles2", null));
      let datos = [];
      snapshot.forEach((childSnapshot) => {
        const childKey = childSnapshot.key;
        const childData = childSnapshot.val();
        childData.idInterno = childKey;
        datos.push({
          label: childData.Nombre,
          value: childData.Nombre,
        });
      });
      setRolesOptions(datos);
    } catch (error) {}
  };
  /**
   * Obtiene la lista de archivos transferibles desde el almacenamiento de Firebase.
   *
   * Esta función recorre todos los archivos dentro de la ruta especificada en `archivosEnCarpetaArborist`,
   * obtiene los metadatos de cada archivo desde Firebase Storage, y determina si cada archivo es transferible o no,
   * basándose en los metadatos personalizados. Luego, actualiza el estado `archivosTraferibles` con los resultados.
   *
   * @async
   * @function ObtenerArchivosTransferibles
   * @returns {Promise<void>}
   */
  const ObtenerArchivosTransferibles = async () => {
    let arrayDatetes = [];
    for (let archivo of archivosEnCarpetaArborist.archivos) {
      if (archivo.includes(".")) {
        const ruta = archivosEnCarpetaArborist.path + "/" + archivo;
        const forestRef = ref(firebase.storage, ruta);

        try {
          const metadata = await getMetadata(forestRef);
          arrayDatetes.push({
            archivo: archivo,
            transferible:
              metadata.customMetadata && metadata.customMetadata.transferible
                ? metadata.customMetadata.transferible
                : true,
          });
        } catch (error) {
          //alert("Error al cambiar la transferibilidad: " + error);
        }
      }
    }
    setArchivosTraferibles(arrayDatetes);
  };
  /**
   * Extrae la parte de la cadena antes de la última barra (`/`), incluida la barra misma.
   *
   * Esta función busca la última barra en la cadena proporcionada. Si se encuentra, retorna todo el contenido
   * de la cadena antes de dicha barra, incluyendo la barra. Si no se encuentra ninguna barra, se retorna la cadena
   * original sin modificaciones.
   *
   * @param {string} cadena - La cadena de texto de la que se extraerá la parte antes de la última barra.
   * @returns {string} La parte de la cadena antes de la última barra, incluida la barra misma, o la cadena original si no se encuentra barra.
   */
  function extraerAntesUltimaBarra(cadena) {
    // Buscar la posición de la última barra en la cadena
    const ultimaBarraIndex = cadena.lastIndexOf("/");

    // Verificar si se encontró la barra
    if (ultimaBarraIndex !== -1) {
      // Extraer la parte de la cadena antes de la última barra, incluida la barra misma
      const parteAntesUltimaBarra = cadena.substring(0, ultimaBarraIndex + 1);
      return parteAntesUltimaBarra;
    } else {
      // Si no se encontró ninguna barra, retornar la cadena original
      return cadena;
    }
  }
  /**
   * Obtiene los datos de la colección "SoloPresi" desde Firebase, según la ruta proporcionada.
   *
   * Esta función accede a la base de datos de Firebase para obtener los elementos almacenados en la ruta
   * especificada dentro de la colección "SoloPresi". Los datos obtenidos se almacenan en el estado local
   * `RolesEnvios` para su uso posterior.
   *
   * @param {string} path - La ruta específica dentro de la colección "SoloPresi" desde donde se extraerán los datos.
   * @returns {Promise<void>} No retorna un valor, pero actualiza el estado `RolesEnvios` con los datos obtenidos.
   *
   * @throws {Error} Si ocurre un error al obtener los datos desde Firebase, se captura y muestra en la consola.
   */
  const obtenerSoloPresi = async (path) => {
    try {
      const soloPresiRef = await get(firebase.getReferencia("SoloPresi/" + path));
      const soloPresi = [];
      soloPresiRef.forEach((childSnapshot) => {
        const childData = childSnapshot.val();
        soloPresi.push(childData);
      });
      setRolesEnvios(soloPresi);
    } catch (error) {
      console.error("Error obteniendo datos", error);
    }
  };
  /**
   * Efecto que se ejecuta al cambiar el estado de `refrescar`.
   *
   * Este `useEffect` se encarga de realizar varias tareas asíncronas al renderizar el componente,
   * como cargar información relacionada con la comunidad, los roles, los documentos y las carpetas
   * asociadas a la comunidad. También, si el usuario tiene un `IdJunta` especificado, navega a la
   * junta correspondiente y carga los archivos asociados a esa carpeta.
   *
   * Funciones que se ejecutan:
   * - `obtenerNombreComunidad`: Obtiene el nombre de la comunidad desde Firebase.
   * - `cargarRoles`: Carga los roles desde Firebase.
   * - `loadDocuments`: Carga los documentos asociados a la comunidad.
   * - `cargarSoloPresi`: Carga la información de la colección "SoloPresi".
   * - Navegación condicional hacia una junta específica si se tiene un `IdJunta` y configuración de
   *   la carpeta de archivos de la junta.
   *
   * Dependencias:
   * - Este efecto depende del estado `refrescar`, lo que significa que se ejecutará cada vez que este
   *   estado cambie.
   *
   * @async
   * @function
   * @returns {void}
   */
  useEffect(async () => {
    if (docusUsuario === "true") {
      // traemos el usuario de firebase

      const referenciaUsuario = await get(
        firebase.getReferencia(`Usuarios/${Identificador}`, null)
      );

      const usuarioData = referenciaUsuario.val();
      usuarioData.idInterno = referenciaUsuario.key;
      usuarioData.Direcciones = {
        Calle: "7º A",
        Enteros: 12.5,
        Escalera: "",
        Letra: "",
        Nueva: false,
        Piso: "",
        Portal: "",
        Reservas: 1,
        Tipo: "inquilino",
        Usuario: "53645046F",
      };
      usuarioData.Clave = referenciaUsuario.key;
      usuarioData.Roles = ["Administrador", "Propietario"];
      usuarioData.uid = referenciaUsuario.key;
      usuarioData.Direcciones2 = "LA BIEJA 12, 7º A";
      console.log("Usuario de Firebase:", usuarioData);

      setUsuario([usuarioData]);
    }
    await obtenerNombreComunidad();
    await cargarRoles();
    await loadDocuments();
    await cargarSoloPresi();

    // Si tiene idJunta Navego a junta la primera vez que entro, luego que se comporte como sea
    if (IdJunta) {
      const TituloJunta = await getTituloJunta(firebase, Identificador, IdJunta);
      const carpetaJunta = `${Identificador}/${nombreJuntasPropietarios}/${TituloJunta}`;
      const carpeta = carpetaJunta.split("/").pop();
      const carpetaActual = await firebase.getFolderContents(carpetaJunta);
      setArchivosEnCarpetaArborist({
        carpeta: carpeta,
        archivos: carpetaActual.map((item) => item.name),
        path: carpetaJunta,
        firstLevel: false,
      });

      setSeleccionNuevaCarpeta(carpetaJunta);
    }
  }, [refrescar]);
  useEffect(() => {
    if (!Identificador) return;

    const dataRef = firebase.getReferencia(`Comunidad/${Identificador}/MigracionDatos`, null);
    let toastId = null;
    let completedRef = false;

    const unsubscribe = onValue(dataRef, (snapshot) => {
      const filesData = snapshot.val();

      if (!filesData || (Array.isArray(filesData) && filesData.length === 0)) {
        // No mostrar ningún toast si no hay archivos
        return;
      }

      const filteredFiles = filesData.filter((item) => {
        const fileName = item.file.split("/").pop();
        return fileName !== "temporal.txt";
      });

      if (filteredFiles.length === 0) {
        toast.warning("⚠️ No hay archivos válidos para migrar.", {
          autoClose: 5000,
          closeOnClick: true,
        });
        return;
      }

      // Mostrar loading solo si aún no se había mostrado
      if (!toastId) {
        toastId = toast.loading("Cargando progreso de migración...");
      }

      const totalFilesCount = filteredFiles.length;
      const transferedFilesCount = filteredFiles.filter(
        (item) => item.status === "transfered"
      ).length;

      const isComplete = transferedFilesCount === totalFilesCount;
      completedRef = isComplete;

      toast.update(toastId, {
        render: isComplete
          ? `✅ Migración completada: ${transferedFilesCount}/${totalFilesCount} archivos.`
          : `📦 Migrando: ${transferedFilesCount}/${totalFilesCount} archivos...`,
        type: isComplete ? "success" : "info",
        isLoading: false,
        autoClose: isComplete ? 5000 : false,
        closeOnClick: true,
      });
    });

    // Escuchar el cierre del toast una sola vez
    toast.onChange((payload) => {
      if (payload.status === "removed" && payload.id === toastId && completedRef) {
        const leidaRef = firebase.getReferencia(`Comunidad/${Identificador}/MigracionDatosLeida`);
        set(leidaRef, true);
      }
    });

    return () => {
      unsubscribe();
      if (toastId) toast.dismiss(toastId); // Solo si se mostró
    };
  }, [Identificador]);

  /**
   * Efecto que se ejecuta cuando cambia el estado de `archivosEnCarpetaArborist`.
   *
   * Este `useEffect` se encarga de llamar a la función `ObtenerArchivosTransferibles` cada vez
   * que el estado `archivosEnCarpetaArborist` cambie. La función `ObtenerArchivosTransferibles`
   * es responsable de verificar la transferibilidad de los archivos en la carpeta actual y
   * actualizar el estado correspondiente.
   *
   * Dependencias:
   * - Este efecto depende del estado `archivosEnCarpetaArborist`, lo que significa que se ejecutará
   *   cada vez que este estado cambie.
   *
   * @async
   * @function
   * @returns {void}
   */
  useEffect(async () => {
    ObtenerArchivosTransferibles();
  }, [archivosEnCarpetaArborist]);
  /**
   * Efecto que se ejecuta cuando cambia el estado de `refrescarSoloPresi`.
   *
   * Este `useEffect` se encarga de llamar a la función `cargarSoloPresi` cada vez
   * que el estado `refrescarSoloPresi` cambie. La función `cargarSoloPresi` es responsable
   * de cargar y establecer la información específica del estado "SoloPresi" para la comunidad.
   *
   * Dependencias:
   * - Este efecto depende del estado `refrescarSoloPresi`, lo que significa que se ejecutará
   *   cada vez que este estado cambie.
   *
   * @async
   * @function
   * @returns {void}
   */
  useEffect(async () => {
    cargarSoloPresi();
  }, [refrescarSoloPresi]);

  /**
   * Maneja el evento de "drop" (arrastre y soltar) de archivos.
   *
   * Esta función se ejecuta cuando un usuario arrastra y suelta archivos en el área de carga.
   * Valida los archivos cargados, asegurándose de que cumplan con los tipos de archivo permitidos
   * y no superen el tamaño máximo permitido. Si los archivos son válidos, los sube a Firebase Storage,
   * actualiza la vista de la carpeta y muestra un mensaje de éxito.
   *
   * **Flujo principal:**
   * 1. Se obtiene la lista de archivos arrastrados.
   * 2. Se valida el tipo de archivo y el tamaño de cada archivo.
   * 3. Los archivos válidos se suben a Firebase Storage.
   * 4. Se actualiza el contenido de la carpeta.
   * 5. Se muestra un mensaje de éxito o error según corresponda.
   *
   * @async
   * @function
   * @param {Object} e - El evento de "drop" que contiene los archivos arrastrados.
   * @throws {string} Si el número de archivos o el tamaño de un archivo no es válido, se lanza un error con un mensaje.
   * @returns {void}
   */
  const handleDrop = async (e) => {
    e.preventDefault();

    try {
      const files = e.dataTransfer.files;

      if (files.length > maxArchivos) {
        throw safeReplace(diccionario.MaximoArchivos, "${var1}", maxArchivos);
      }

      const uploadPromises = [];
      let totalSize = 0;

      let archivos = [];

      for (const file of files) {
        // Check file type
        if (!fileTypes.includes(file.type)) {
          throw safeReplace(diccionario.TipoArchivoNoPermitido, "${var1}", file.type);
        }

        // Check file size
        if (file.size > maxFileSizeMB * 1024 * 1024) {
          throw safeReplace(
            safeReplace(diccionario.ambioEstadoIncidenciaCodigo, "${var1}", file.type),
            "${var2}",
            maxFileSizeMB
          );
        }

        totalSize += file.size;

        const fileRef = ref(firebase.storage, `${archivosEnCarpetaArborist.path}/${file.name}`);

        const uploadPromise = uploadBytes(fileRef, file).then((snapshot) => {});
        archivos.push(file.name);
        uploadPromises.push(uploadPromise);
      }

      // Wait for all uploads to complete
      await Promise.all(uploadPromises);

      setSeleccionNuevaCarpeta(archivosEnCarpetaArborist.path);
      await refrescarCarpetaNueva();
      const carpetaActual = await firebase.getFolderContents(archivosEnCarpetaArborist.path);
      const carpeta =
        archivosEnCarpetaArborist.path !== Identificador + "/"
          ? archivosEnCarpetaArborist.path.split("/").pop()
          : archivosEnCarpetaArborist.path + "/";
      if (docusUsuario !== "true") {
        setArchivosEnCarpetaArborist({
          carpeta: carpeta,
          archivos: carpetaActual.map((item) => item.name),
          path: archivosEnCarpetaArborist.path,
          firstLevel: archivosEnCarpetaArborist.path === Identificador + "/" ? true : false,
        });
      }
      setLoading(false);
      toast.success(diccionario.ArchivosSubidosCorrectamente, getCustomToastOptions(toast));
    } catch (error) {
      toast.error(error, getCustomToastOptions(toast, "error"));
    }
    setEstaArrastrandoEncima(false);
  };

  /**
   * Muestra el campo de entrada para crear o seleccionar una carpeta.
   *
   * Esta función se ejecuta cuando se necesita mostrar un campo de entrada en la interfaz
   * para permitir al usuario ingresar el nombre de una nueva carpeta o seleccionar una carpeta
   * existente. Se activa cuando el usuario realiza una acción que requiere mostrar el campo de entrada.
   *
   * @function
   * @returns {void}
   */
  const handleCarpeta = () => {
    setMostrarInput(true);
  };
  /**
   * Maneja el cambio en el valor del campo de entrada para el nombre de la carpeta.
   *
   * Esta función se ejecuta cada vez que el usuario modifica el valor del campo de entrada
   * relacionado con el nombre de la carpeta. Actualiza el estado `nombreCarpeta` con el
   * nuevo valor proporcionado en el evento.
   *
   * @function
   * @param {Object} event - El evento que contiene el nuevo valor del campo de entrada.
   * @param {string} event.target.value - El nuevo valor del campo de entrada.
   * @returns {void}
   */
  const handleChange = (event) => {
    setNombreCarpeta(event.target.value);
  };
  /**
   * Abre el modal de envío.
   *
   * Esta función se encarga de cambiar el estado `modalOpen` a `true`, lo que indica
   * que el modal de envío debe mostrarse en la interfaz de usuario.
   *
   * @function
   * @returns {void}
   */
  const modalEnvio = () => {
    setModalOpen(true);
  };

  /**
   * Crea una nueva carpeta en el almacenamiento de Firebase.
   *
   * Esta función realiza la creación de una nueva carpeta en el almacenamiento de Firebase
   * si el nombre de la carpeta es válido. Primero valida que el nombre no esté vacío y que no
   * exista ya un archivo con ese nombre en el mismo nivel. Si todo es correcto, sube un archivo
   * temporal para crear la carpeta y luego actualiza el estado con la nueva carpeta y su ruta.
   *
   * Además, si ocurre un error en el proceso de creación, muestra un mensaje de error en la interfaz.
   *
   * @async
   * @function
   * @returns {void}
   */
  const crearCosa = async () => {
    if (nombreCarpeta === "") {
      toast.error(diccionario.NombreCarpetaVacio, getCustomToastOptions(toast, "error"));
      return;
    }

    if (archivosEnCarpetaArborist.archivos.includes(nombreCarpeta)) {
      toast.error(diccionario.MismoNombreArchivoMismoNivel, getCustomToastOptions(toast, "error"));
      return;
    }
    try {
      const nombreFinal = nombreCarpeta.trim();
      const spaceRef = ref(
        firebase.storage,
        archivosEnCarpetaArborist.path + "/" + nombreFinal + "/temporal.txt"
      );

      const message = "mensajesublemuinal";

      uploadString(spaceRef, message).then(async (snapshot) => {
        setMostrarInput(false);
        setNombreCarpeta("");
        await refrescarCarpetaNueva();
        setArchivosEnCarpetaArborist({
          carpeta: nombreFinal,
          path: archivosEnCarpetaArborist.path + "/" + nombreFinal,
          archivos: [],
        });
        let rutaCarpetanueva = archivosEnCarpetaArborist.path + "/" + nombreFinal;
        rutaCarpetanueva = rutaCarpetanueva.replace(/\/\/+/g, "/");

        setSeleccionNuevaCarpeta(rutaCarpetanueva);
        toast.success(diccionario.CarpetaCreadaCorrectamente, getCustomToastOptions(toast));
      });
    } catch (error) {
      toast.error(diccionario.ErrorCrearCarpeta, getCustomToastOptions(toast, "error"));
    }
  };
  /**
   * Asigna opciones a una carpeta en el almacenamiento de Firebase bajo la ruta `SoloPresi/{pathCarpeta}`.
   *
   * Esta función toma un array de opciones, extrae las etiquetas de cada opción y las guarda en Firebase
   * bajo la ruta especificada. Después de guardar los datos, muestra un mensaje de éxito en la interfaz y
   * actualiza el estado de la aplicación. Además, vuelve a cargar la información de "SoloPresi" y refresca los roles.
   *
   * @async
   * @function
   * @param {Array} e - Array de opciones seleccionadas, donde cada opción contiene una propiedad `label`.
   * @param {string} pathCarpeta - Ruta en el almacenamiento de Firebase donde se deben guardar los datos.
   * @returns {void}
   */
  const asignarSoloPresi = async (e, pathCarpeta) => {
    const opts = [];
    e.map((opcion) => {
      opts.push(opcion.label);
    });
    const soloPresiUp = firebase.getReferencia(`SoloPresi/${pathCarpeta}`.toString(), null);
    await set(soloPresiUp, opts);
    toast.success(diccionario.DatosGuardadosCorrectamente, getCustomToastOptions(toast));
    cargarSoloPresi();
    setRefrescarRoles(!refrescarRoles);
  };

  /**
   * Mueve un archivo o carpeta dentro de Firebase Storage a una nueva ubicación.
   *
   * Esta función se encarga de mover archivos o carpetas de una ubicación a otra en el almacenamiento de Firebase.
   * Verifica que no se intente mover carpetas protegidas, y actualiza los roles de la carpeta en caso de que sea necesario.
   * También actualiza la vista del árbol de carpetas después de la operación de movimiento.
   *
   * @async
   * @function
   * @param {Object} param - Parámetros de movimiento.
   * @param {Array} param.dragIds - Identificadores de los elementos a mover (debe contener al menos un elemento).
   * @param {string} param.parentId - ID de la carpeta de destino.
   * @param {number} param.index - Índice del archivo o carpeta movida.
   *
   * @returns {void}
   */
  const onMove = async ({ dragIds, parentId, index }) => {
    // No permito mover carpetas protegidas....
    if (dragIds[0] === nombreDocumentacionGeneral || dragIds[0] === nombreJuntasPropietarios) {
      toast.error(diccionario.ErrorMoverCarpetaNoPermitido, getCustomToastOptions(toast, "error"));
      return 0;
    }

    setLoading(true);
    const movedNode = findNodeById(gData, dragIds[0]);
    // FALTA COMPROBAR SI EXISTE DESTINO. SI EXISTE DESTINO NO DEJAR MOVER
    const moveFile = httpsCallable(functions, "moveFile");
    parentId = parentId === null ? "./" : parentId;

    if (parentId === "./") {
      parentId = Identificador;
    }

    if (docusUsuario === "true" && parentId === Identificador) {
      parentId = `usuarios/${Identificador}`;
    }

    moveFile({
      origin: dragIds[0],
      destination: parentId,
      bucket: firebase.storage._bucket.bucket,
      type: movedNode.isFile === true ? "file" : "folder",
    })
      .then(async (res) => {
        if (!movedNode.isFile && dragIds && parentId) {
          const pathOrigen = dragIds[0];
          const pathDestino = parentId;

          let partes = pathOrigen.split("/");
          partes.shift();
          //let rolesOrigen = soloPresi;
          let rolesOrigen =
            archivosEnCarpetaArborist.path.includes(nombreDocumentacionGeneral) &&
            Identificador !== nombreDocumentacionGeneral
              ? soloPresi[nombreDocumentacionGeneral]
              : soloPresi;
          let last = "";
          partes.map((parte) => {
            rolesOrigen = rolesOrigen ? rolesOrigen[parte.toString()] : rolesOrigen;
            last = parte;
          });

          const soloPresiUp = firebase.getReferencia(
            `SoloPresi/${pathDestino}/${last}`.toString(),
            null
          );
          if (Array.isArray(rolesOrigen)) {
            await set(soloPresiUp, rolesOrigen);
          }
          const refDelete = firebase.getReferencia(`SoloPresi/${pathOrigen}`.toString());
          await remove(refDelete);
        }
        refresh();
        setSeleccionNuevaCarpeta(parentId);
        //await refrescarCarpetaNueva();
        let carpetaActual = await firebase.getFolderContents(parentId);
        const carpeta =
          archivosEnCarpetaArborist.path !== Identificador + "/"
            ? parentId.split("/").pop()
            : parentId + "/";

        // Añado la carpeta 10 Documentacion General si no estamos en la documentación general desde el despacho y estamos en raíz
        if (
          Identificador !== nombreDocumentacionGeneral &&
          docusUsuario !== "true" &&
          parentId === Identificador
        ) {
          let docuGeneral = await firebase.getFolderContents(nombreDocumentacionGeneral);
          docuGeneral = transformData(docuGeneral);
          //docuGeneral = docuGeneral.filter((carpeta) => carpeta.id === nombreDocumentacionGeneral);
          carpetaActual = carpetaActual.concat(docuGeneral);
        }

        setArchivosEnCarpetaArborist({
          carpeta: carpeta,
          archivos: carpetaActual.map((item) => item.name),
          path: parentId,
          firstLevel: parentId === Identificador + "/" ? true : false,
        });
        toast.success(diccionario.CarpetaMovidaCorrectamente, getCustomToastOptions(toast));
      })
      .catch((e) => {
        console.log("error", e);
        toast.error(diccionario.ErrorMoverCarpeta, getCustomToastOptions(toast, "error"));
      });
  };

  /**
   * Modifica el nombre de una carpeta o archivo y actualiza sus metadatos en Firebase.
   *
   * Esta función se utiliza para cambiar el nombre de una carpeta o archivo dentro del almacenamiento de Firebase.
   * Verifica que el nuevo nombre no sea duplicado en el mismo nivel y maneja la actualización de los metadatos
   * relacionados con la transferibilidad. Si la carpeta es protegida, no permite su modificación.
   *
   * @async
   * @function
   * @param {Object} e - El evento de modificación que contiene el nuevo nombre de la carpeta o archivo.
   *
   * @returns {void}
   */
  const handleModificar = async (e) => {
    if (esGeneral) {
      const carpetaAnterior = archivosEnCarpetaArborist.path.split("/").slice(0, -1).join("/");
      const comprobarCarpetaAnterior = await firebase.getFolderContents(carpetaAnterior);

      if (comprobarCarpetaAnterior.some((item) => item.name === inputValue)) {
        toast.error(
          diccionario.MismoNombreArchivoMismoNivel,
          getCustomToastOptions(toast, "error")
        );
        return 0;
      }
    }

    if (pathCarpetaModificar === Identificador + "/" + nombreJuntasPropietarios) {
      toast.error(diccionario.Carpeta03NoBorrar, getCustomToastOptions(toast, "error"));
      return 0;
    }

    if (!nombreCarpetaModificar.includes(".")) {
      if (archivosEnCarpetaArborist.archivos.includes(inputValue)) {
        toast.error(
          diccionario.MismoNombreArchivoMismoNivel,
          getCustomToastOptions(toast, "error")
        );
        return;
      }
    }

    const transferibles = archivosTraferibles
      .filter((archivo) => archivo.archivo === nombreCarpetaModificar)
      .map((archivo) => archivo.transferible);

    if (checkedTransferible == false) {
      if (transferibles == "false" && nombreCarpetaModificar.split(".")[0] == inputValue) {
        toast.error(diccionario.GuardarCambiosModificar, getCustomToastOptions(toast, "error"));
        return;
      }
      const forestRef = ref(firebase.storage, pathCarpetaModificar);

      const newMetadata = {
        customMetadata: {
          transferible: "false", // Debes definir metadatos personalizados dentro de `customMetadata`
        },
      };
      updateMetadata(forestRef, newMetadata)
        .then((metadata) => {
          //console.log("metadata", metadata);
        })
        .catch((error) => {
          //alert("Error al cambiar la transferibilidad" + error);
        });
    }
    if (checkedTransferible == true) {
      if (transferibles == "true" && nombreCarpetaModificar.split(".")[0] == inputValue) {
        toast.error(diccionario.GuardarCambiosModificar, getCustomToastOptions(toast, "error"));
        return;
      }
      const forestRef = ref(firebase.storage, pathCarpetaModificar);

      const newMetadata = {
        customMetadata: {
          transferible: "true", // Debes definir metadatos personalizados dentro de `customMetadata`
        },
      };
      updateMetadata(forestRef, newMetadata)
        .then((metadata) => {
          //console.log("metadata", metadata);
        })
        .catch((error) => {
          alert(diccionario.ErrorCambiarTransferibilidad + error);
        });
    }

    const partes = pathCarpetaModificar.split("/");
    const resultado = partes.slice(0, -1).join("/");
    const nombreRepetido = await firebase.getFolderContents(resultado);
    const nombres = nombreRepetido.map((item) => item.name);

    let nombreOrigen = pathCarpetaModificar;

    const temporalOrigen = nombreOrigen;
    let archivosEnCarpeta = esGeneral
      ? archivosEnCarpetaArborist.path.split("/").slice(0, -1).join("/")
      : archivosEnCarpetaArborist.path;

    let nombreDestino = archivosEnCarpeta + "/" + inputValue;
    nombreDestino = nombreDestino.replace(/\/\/+/g, "/");

    if (nombreOrigen.includes(".")) {
      const extension = nombreOrigen.split(".").pop();
      nombreDestino = nombreDestino + "." + extension;
    }

    setLoading(true);
    const movedNode = findNodeById(gData, nombreOrigen);

    const moveFile = httpsCallable(functions, "moveFile");

    nombreDestino = nombreDestino === null ? "./" : nombreDestino;

    const temporalDestino = nombreDestino;

    moveFile({
      origin: nombreOrigen,
      destination: nombreDestino,
      bucket: firebase.storage._bucket.bucket,
      type: "renameFolder",
    })
      .then(async (res) => {
        let carpetaActual = await firebase.getFolderContents(
          esGeneral ? nombreDestino : nombreDestino.substring(0, nombreDestino.lastIndexOf("/"))
        );
        const carpeta =
          nombreDestino !== Identificador + "/"
            ? nombreDestino.split("/").pop()
            : nombreDestino + "/";

        nombreDestino = esGeneral
          ? nombreDestino
          : nombreDestino.substring(0, nombreDestino.lastIndexOf("/"));
        let treeElements = await firebase.getFolderContents(rootFolder);

        // Añado la carpeta 10 Documentacion General si no estamos en docus usuario

        if (docusUsuario !== "true" && Identificador !== nombreDocumentacionGeneral) {
          let docuGeneral = await firebase.getFolderContents(nombreDocumentacionGeneral);
          docuGeneral = transformData(docuGeneral);

          treeElements = treeElements.concat(docuGeneral);
          //carpetaActual.push(docuGeneral);
          if (archivosEnCarpetaArborist.path === Identificador + "/") {
            carpetaActual = carpetaActual.concat(docuGeneral);
          }
        }

        /*
        treeElements.map(rama => {
          if(rama.id===nombreDocumentacionGeneral){
            rama.nameUPD = "Documentación general";
          }
        });
        */
        setGData(treeElements);

        setArchivosEnCarpetaArborist({
          carpeta: carpeta,
          archivos: carpetaActual.map((item) => item.name),
          path: nombreDestino,
          firstLevel: nombreDestino === Identificador + "/" ? true : false,
        });

        toast.success(diccionario.NombreCambiadoCorrectamente, getCustomToastOptions(toast));
        setShowDialogModificar(false);
        setLoading(false);

        setInputValue("");

        setSeleccionNuevaCarpeta(nombreDestino);
        /*
        let gDataModificado = renameNodeById(gData, nombreOrigen, nombreDestino);
        
        setGData(gDataModificado);
 */
        //setRefrescar(!refrescar);

        setEsGeneral(false);

        if (!temporalOrigen.includes(".") && temporalOrigen && temporalDestino) {
          const pathOrigen = temporalOrigen;
          const pathDestino = temporalDestino;

          let partes = pathOrigen.split("/");
          partes.shift();
          let rolesOrigen = soloPresi;
          partes.map((parte) => {
            rolesOrigen = rolesOrigen ? rolesOrigen[parte.toString()] : rolesOrigen;
          });
          const soloPresiUp = firebase.getReferencia(`SoloPresi/${pathDestino}`.toString(), null);
          if (Array.isArray(rolesOrigen)) {
            await set(soloPresiUp, rolesOrigen);
          }
          const refDelete = firebase.getReferencia(`SoloPresi/${pathOrigen}`.toString());
          await remove(refDelete);
          setRefrescarSoloPresi(!refrescarSoloPresi);
        }
      })
      .catch((e) => {
        toast.error(diccionario.ErrorCambiarNombre, getCustomToastOptions(toast, "error"));
        console.log("error", e);
      });
  };
  /**
   * Muestra un diálogo de confirmación para ejecutar una acción específica (como borrar o modificar un archivo o carpeta).
   *
   * Esta función configura el contenido del diálogo (título, cuerpo, etc.) y establece la función que se debe ejecutar
   * cuando el usuario confirme la acción. Además, gestiona la visualización del diálogo y permite al usuario
   * ingresar datos si es necesario (a través de un campo de entrada).
   *
   * @function
   * @param {Function} callbackFunction - La función a ejecutar cuando el usuario confirme la acción (por ejemplo, borrar o modificar).
   * @param {string} pathBorrar - La ruta de la carpeta o archivo a modificar o borrar.
   * @param {Object} mensaje - El mensaje que se mostrará en el diálogo (incluye título y cuerpo del mensaje).
   * @param {JSX.Element} input - Un campo de entrada para capturar información adicional del usuario (si es necesario).
   * @param {Object} e - El evento que desencadena la acción (por ejemplo, un clic en un botón).
   * @param {string} nombreCambiar - El nombre de la carpeta o archivo que se cambiará (si aplica).
   *
   * @returns {void}
   */
  const handleMostrarDialogo = (callbackFunction, pathBorrar, mensaje, input, e, nombreCambiar) => {
    setDialogoContenido({
      titulo: mensaje.titulo,
      cuerpo: mensaje.cuperpomensaje,
      path: pathBorrar,
      ejecutarFuncion: () => callbackFunction(pathBorrar, e),
      inputElement: input,
      nombreCambiar: nombreCambiar,
    });

    setShowDialog(true);
  };
  /**
   * Muestra un diálogo para cambiar el nombre de un archivo o carpeta, y maneja la lógica relacionada con los
   * archivos transferibles antes de permitir la modificación.
   *
   * Esta función verifica si el archivo o carpeta a cambiar tiene metadatos relacionados con su transferibilidad,
   * ejecuta un proceso relacionado (a través de la función `trapaceria`), y luego configura el estado del componente
   * para permitir la edición del nombre del archivo o carpeta.
   *
   * @function
   * @param {string} pathOrigen - La ruta completa del archivo o carpeta que se va a modificar.
   * @param {string} nombreCambiar - El nombre del archivo o carpeta que se desea cambiar.
   *
   * @returns {void}
   */
  const handleMostrarDialogoCambiar = async (pathOrigen, nombreCambiar) => {
    const transferibles = archivosTraferibles
      .filter((archivo) => archivo.archivo === nombreCambiar)
      .map((archivo) => archivo.transferible);

    await trapaceria(transferibles);

    setInputValue(nombreCambiar.split(".")[0]);
    setNombreCarpetaModificar(nombreCambiar);
    setPathCarpetaModificar(pathOrigen);
    abrirDialogoModificar();
  };
  /**
   * Ajusta el estado de la transferibilidad en función del valor proporcionado.
   *
   * Esta función se encarga de actualizar el estado de la propiedad `checkedTransferible` en función de un valor
   * específico ("true" o "false"). El valor de `cosagorda` indica si el archivo o carpeta es transferible.
   *
   * @function
   * @param {string} cosagorda - El valor que indica la transferibilidad del archivo o carpeta.
   *                              Puede ser "true" o "false".
   *
   * @returns {void}
   */
  const trapaceria = async (cosagorda) => {
    if (cosagorda == "true") {
      setCheckedTransferible(true);
    }

    if (cosagorda == "false") {
      setCheckedTransferible(false);
    }
  };
  /**
   * Abre el diálogo para modificar un archivo o carpeta.
   *
   * Esta función establece el estado `showDialogModificar` como `true`, lo que permite mostrar el
   * diálogo de modificación en la interfaz de usuario.
   *
   * Es comúnmente utilizada cuando se desea permitir al usuario realizar cambios en el nombre o propiedades
   * de un archivo o carpeta.
   *
   * @function
   * @returns {void}
   */
  const abrirDialogoModificar = () => {
    setShowDialogModificar(true);
  };
  /**
   * Elimina la última parte de una ruta (después de la última barra '/') y retorna la ruta restante.
   *
   * Esta función es útil cuando se desea obtener la ruta de un archivo o carpeta sin incluir su nombre
   * o última sección, es decir, eliminar la parte posterior a la última barra (`/`).
   *
   * @param {string} input - La ruta completa de la cual se desea eliminar la última parte.
   * @returns {string} La ruta sin la última parte después de la última barra `/`.
   */
  const removeLastPartOfPath = (input) => {
    // Find the last occurrence of '/'
    const lastSlashIndex = input.lastIndexOf("/");

    // Return everything before the last '/'
    if (lastSlashIndex !== -1) {
      return input.substring(0, lastSlashIndex);
    } else {
      // If there's no '/' in the input, return the input as is
      return input;
    }
  };
  /**
   * Maneja la acción de borrar una carpeta en el sistema, verificando si la carpeta
   * es una carpeta protegida antes de proceder con la eliminación.
   *
   * Primero, verifica si la carpeta a borrar es una carpeta protegida (como "Juntas Propietarios").
   * Si es así, muestra un mensaje de error y no realiza ninguna acción. Si no es una carpeta protegida,
   * intenta borrar la carpeta, recargar los documentos y navegar al directorio superior.
   *
   * @param {string} path - La ruta completa de la carpeta a borrar.
   */
  const handleBorrarCarpeta = async (path) => {
    if (path === Identificador + "/" + nombreJuntasPropietarios) {
      toast.error(diccionario.Carpeta03NoBorrar, getCustomToastOptions(toast, "error"));
      setShowDialog(false);
      return;
    }

    try {
      await borrarCarpeta(path);
      await loadDocuments();
      await navegarPath(removeLastPartOfPath(path));
      //refresh();
      setShowDialog(false);
    } catch (error) {
      console.error("Error al borrar el archivo/carpeta", error);
    }
  };
  /**
   * Borra una carpeta y su contenido (archivos y subcarpetas) de Firebase Storage,
   * además de eliminar cualquier entrada relacionada con la carpeta en `SoloPresi`.
   *
   * @param {string} path - La ruta de la carpeta a borrar en Firebase Storage.
   */
  const borrarCarpeta = async (path) => {
    try {
      let refGeneral = ref(firebase.storage, path);
      const items = await listAll(refGeneral);

      const deleteFilePromises = items.items.map(async (fileRef) => {
        let refDel = ref(firebase.storage, fileRef._location.path);

        await deleteObject(refDel);
      });

      const deleteSubfolderPromises = items.prefixes.map(async (subfolderRef) => {
        const subfolderPath = subfolderRef._location.path;
        return borrarCarpeta(subfolderPath);
      });

      // Wait for all file and subfolder deletions to complete
      await Promise.all([...deleteFilePromises, ...deleteSubfolderPromises]);
      // Borrado de roles en soloPresi
      const refDelete = firebase.getReferencia(`SoloPresi/${path}`.toString());
      await remove(refDelete);
    } catch (error) {
      console.error("Error al borrar el archivo/carpeta", error);
    }
  };
  /**
   * Obtiene la ruta de una carpeta sin el nombre del archivo o carpeta al final.
   *
   * @param {string} input - La ruta completa que puede incluir un archivo o carpeta al final.
   * @returns {string} - La ruta de la carpeta sin el archivo o carpeta al final.
   */
  const getPathWithoutFile = (input) => {
    // Find the last occurrence of '/'
    const lastSlashIndex = input.lastIndexOf("/");

    // Return everything before the last '/'
    return input.substring(0, lastSlashIndex);
  };
  /**
   * Maneja la eliminación de un archivo en Firebase Storage.
   *
   * @param {string} archivo - La ruta completa del archivo a eliminar en Firebase Storage.
   */
  const handleBorrarFichero = async (archivo) => {
    const desertRef = ref(firebase.storage, archivo);

    try {
      await deleteFileOrFolder(desertRef, archivo);
      await loadDocuments();
      await navegarPath(getPathWithoutFile(archivo));
      //refresh();
      toast.success(diccionario.ArchivoBorradoCorrectamente, getCustomToastOptions(toast));
      setShowDialog(false);
    } catch (error) {
      console.error("Error al borrar el archivo/carpeta", error);
    }
  };
  /**
   * Elimina un archivo o carpeta de Firebase Storage.
   *
   * @param {Reference} ref - La referencia del archivo o carpeta en Firebase Storage.
   * @param {string} name - El nombre del archivo o carpeta a eliminar.
   *
   * @throws {Error} Si ocurre un error durante la eliminación, el error será mostrado en la consola.
   */
  const deleteFileOrFolder = async (ref, name) => {
    try {
      await deleteObject(ref);
      /*
      setArchivosEnCarpetaArborist((prevArchivos) => ({
        carpeta: prevArchivos.carpeta,
        archivos: prevArchivos.archivos.filter((a) => a !== name),
        path: prevArchivos.path,
      }));
      */
    } catch (error) {
      console.error("Error al borrar el archivo/carpeta: " + name, error);
    }
  };
  /**
   * Maneja el proceso de carga de archivos, creando un elemento de entrada de archivos
   * y validando las condiciones para la carga de archivos en Firebase Storage.
   *
   * @throws {string} Si el tipo de archivo no es permitido o el tamaño del archivo excede el límite,
   *                  se lanza un error con un mensaje correspondiente.
   */
  const handleClick = () => {
    // Crear elemento de entrada de archivos

    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;

    const uploadPromises = [];
    // Adjuntar escucha de eventos para la selección de archivos
    input.addEventListener("change", async (event) => {
      const files = event.target.files;

      const uploadPromises = [];
      if (files.length > 0) {
        try {
          const uploadPromises = [];
          let totalSize = 0;

          for (const file of files) {
            if (!fileTypes.includes(file.type)) {
              console.error(`Tipo de archivo no permitido: ${file.type}`);
              throw diccionario.TipoArchivoNoPermitido;
            }
            if (file.size > maxFileSizeMB * 1024 * 1024) {
              throw safeReplace(
                safeReplace(diccionario.ArchivoTamañoMaximoSuperado, "${var1}", file.type),
                "${var2}",
                maxFileSizeMB
              );
            }
            if (files.length > maxArchivos) {
              throw safeReplace(diccionario.MaximoArchivos, "${var1}", maxArchivos);
            }

            totalSize += file.size;

            const fileRef = ref(firebase.storage, `${archivosEnCarpetaArborist.path}/${file.name}`);

            const uploadPromise = uploadBytes(fileRef, file).then((snapshot) => {});
            uploadPromises.push(uploadPromise);

            totalSize += file.size;
          }
          /// Antes
          /*
                await Promise.all(uploadPromises);
                await refrescarCarpetaNueva();
                const carpetaActual = await firebase.getFolderContents(archivosEnCarpetaArborist.path);
                const carpeta = archivosEnCarpetaArborist.path.split("/").pop();
                if (docusUsuario !== "true") {
                  setArchivosEnCarpetaArborist({
                    carpeta: carpeta,
                    archivos: carpetaActual.map((item) => item.name),
                    path: archivosEnCarpetaArborist.path,
                    firstLevel: archivosEnCarpetaArborist.path === Identificador + "/" ? true : false,
                  });
                }
                setLoading(false);
                toast.success(diccionario.ArchivosSubidosCorrectamente, getCustomToastOptions(toast));
      */
          /// Despues (esto viene del ondrop)
          setSeleccionNuevaCarpeta(archivosEnCarpetaArborist.path);
          await refrescarCarpetaNueva();
          const carpetaActual = await firebase.getFolderContents(archivosEnCarpetaArborist.path);
          const carpeta =
            archivosEnCarpetaArborist.path !== Identificador + "/"
              ? archivosEnCarpetaArborist.path.split("/").pop()
              : archivosEnCarpetaArborist.path + "/";
          if (docusUsuario !== "true") {
            setArchivosEnCarpetaArborist({
              carpeta: carpeta,
              archivos: carpetaActual.map((item) => item.name),
              path: archivosEnCarpetaArborist.path,
              firstLevel: archivosEnCarpetaArborist.path === Identificador + "/" ? true : false,
            });
          }
          setLoading(false);
          toast.success(diccionario.ArchivosSubidosCorrectamente, getCustomToastOptions(toast));
        } catch (error) {
          toast.error(error, getCustomToastOptions(toast, "error"));
          console.error("Error al cargar los archivos:", error);
        }
      }
    });

    // Activar el cuadro de diálogo de archivos
    input.click();
  };
  /**
   * Valida los caracteres introducidos en un campo de texto para asegurar que no contenga
   * los caracteres "/" o ".", los cuales no están permitidos para los nombres de carpetas.
   *
   * @param {KeyboardEvent} event - El evento de teclado que se dispara cuando el usuario
   *                                escribe un carácter en el campo de texto.
   * @returns {void}
   *
   * @description:
   * La función se usa para prevenir que el usuario ingrese los caracteres "/" o "." en los
   * nombres de carpetas. Estos caracteres no son permitidos para las carpetas en el sistema.
   * Si el usuario intenta escribir estos caracteres, la función evita la acción con `event.preventDefault()`.
   */
  const validarCaracteresCarpeta = (event) => {
    // Disallow "/" and "." characters
    if (event.key === "/" || event.key === ".") {
      event.preventDefault();
    }
  };

  /**
   * Valida el texto que se pega en un campo de texto, asegurando que no contenga
   * los caracteres "/" o ".", que no están permitidos para los nombres de carpetas.
   *
   * @param {ClipboardEvent} event - El evento de pegado que se dispara cuando el usuario
   *                                 pega contenido en el campo de texto.
   * @returns {void}
   *
   * @description:
   * La función se usa para prevenir que el usuario pegue texto que contenga los caracteres
   * "/" o ".", los cuales no están permitidos para los nombres de carpetas. Si el texto
   * pegado contiene estos caracteres, la función evita la acción con `event.preventDefault()`.
   */
  const validarCaracteresCarpetaPaste = (event) => {
    // Disallow "/" and "." characters for pasting
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData("text");
    if (pastedText.includes("/") || pastedText.includes(".")) {
      event.preventDefault();
    }
  };
  /**
   * Navega a una carpeta especificada por su ruta, obteniendo y mostrando su contenido.
   * Además, si se navega a la raíz y no estamos en los documentos de usuario,
   * añade la carpeta de "Documentación General" de forma artificial.
   *
   * @param {string} path - La ruta de la carpeta a la que se desea navegar.
   * @returns {void}
   *
   * @description:
   * La función se encarga de actualizar la vista para mostrar el contenido de la carpeta
   * especificada por la ruta. Si se está navegando hacia la raíz y no se está en el modo
   * de documentos de usuario, la función agrega la carpeta "Documentación General" a la lista
   * de archivos, siempre que la ruta no coincida con el identificador de la documentación general.
   */
  const navegarPath = async (path) => {
    //const nodoSeleccionado = findNodeById(gData,path);
    const carpeta = path.split("/").pop();
    let carpetaActual = await firebase.getFolderContents(path);

    // Si estamos navegando a raíz y no estamos en documentos de usuario añado artificialmente la carpeta de documentación general

    if (
      path === Identificador &&
      docusUsuario !== "true" &&
      Identificador !== nombreDocumentacionGeneral
    ) {
      let docuGeneral = await firebase.getFolderContents(nombreDocumentacionGeneral);
      docuGeneral = transformData(docuGeneral);

      carpetaActual = carpetaActual.concat(docuGeneral);
    }

    setArchivosEnCarpetaArborist({
      carpeta: carpeta,
      archivos: carpetaActual.map((item) => item.name),
      path: path,
      firstLevel: path === Identificador + "/" ? true : false,
    });

    setSeleccionNuevaCarpeta(path);
  };

  /**
   * Componente que renderiza una ruta jerárquica de carpetas como enlaces clicables.
   * Permite navegar entre las diferentes carpetas al hacer clic en los enlaces correspondientes.
   *
   * @param {Object} props - Las propiedades del componente.
   * @param {string} props.ruta - La ruta completa de las carpetas a mostrar como enlaces, separadas por "/".
   * @returns {JSX.Element} Un componente JSX que renderiza los enlaces de la ruta jerárquica.
   *
   * @description:
   * Este componente divide la cadena `ruta` en partes usando el carácter "/" como delimitador.
   * Luego, genera un enlace para cada parte de la ruta, permitiendo al usuario hacer clic para navegar
   * a la carpeta correspondiente. Además, ajusta el nombre de la carpeta si estamos en un contexto
   * de "Documentación General" o "Mi Carpeta" en función de la propiedad `docusUsuario`.
   */
  const RutaEnlaces = ({ ruta }) => {
    // Dividir la cadena de ruta en partes usando "/"
    let partes = ruta.split("/").filter((part) => part.trim() !== "");
    //partes = partes.filter(part => part !== 'usuarios'); //
    let part = "";
    return (
      <div className="path-clickable">
        {partes.map((nombre, index) => {
          if (!(docusUsuario === "true" && index === 0)) {
            let part = partes.slice(0, index + 1).join("/");

            const nombreEspecial =
              docusUsuario === "true"
                ? "Mi Carpeta"
                : Identificador !== "10 Documentación general"
                ? "Raíz"
                : diccionario.DocumentacionGeneral;
            return (
              <React.Fragment key={index}>
                <a onClick={() => navegarPath(part)}>
                  {nombre === Identificador
                    ? nombreEspecial
                    : nombre === "10 Documentación general"
                    ? "Documentación general"
                    : nombre}
                </a>
                {index < partes.length - 1 && <span>&gt;</span>}
              </React.Fragment>
            );
          }
        })}
      </div>
    );
  };

  /**
   * Maneja el cambio de valor en un campo de entrada.
   * Esta función actualiza el estado del valor del campo de entrada.
   *
   * @param {Object} e - El evento del cambio de valor en el campo de entrada.
   * @param {string} e.target.value - El valor ingresado en el campo de entrada.
   * @returns {void} No retorna nada, solo actualiza el estado.
   *
   * @description:
   * Esta función se ejecuta cada vez que el valor de un campo de entrada cambia.
   * El valor ingresado se establece en el estado utilizando la función `setInputValue`.
   */
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  /**
   * Componente funcional de React que renderiza un cursor personalizado.
   * Este componente utiliza las propiedades `top` y `left` para posicionar
   * el cursor en la pantalla según las coordenadas proporcionadas.
   *
   * @param {Object} props - Las propiedades que recibe el componente.
   * @param {number} props.top - La posición vertical del cursor.
   * @param {number} props.left - La posición horizontal del cursor.
   *
   * @returns {JSX.Element} Un elemento `div` con clases y estilos aplicados para
   *                       mostrar un cursor en la posición especificada.
   *
   * @description:
   * El componente `Cursor` permite crear un cursor visual que se puede posicionar
   * dinámicamente en la pantalla. Las posiciones `top` y `left` se pasan como propiedades
   * para ajustar la ubicación del cursor. El componente se representa como un `div` con
   * la clase `barrabaja`, que probablemente aplica estilos CSS definidos previamente.
   */
  const Cursor = ({ top, left }) => {
    return React.createElement("div", {
      className: "barrabaja",
      style: { top, left },
    });
  };

  /**
   * Alterna el estado de la variable `checkedTransferible` entre `true` y `false`.
   * Además, establece la variable `deshabilidato` a `false`, habilitando un componente o acción dependiente de este estado.
   *
   * @function
   * @returns {void}
   */
  const toggleChecked = () => {
    setCheckedTransferible(!checkedTransferible);
    setDeshabilidato(false); // Cambiamos el valor de true a false y viceversa
  };
  /**
   * Verifica si la ruta proporcionada comienza con el prefijo "10 Documentación general".
   *
   * @function
   * @param {string} path - La ruta que se desea verificar.
   * @returns {boolean} Retorna `true` si la ruta comienza con el prefijo "10 Documentación general", de lo contrario retorna `false`.
   */
  const dentroDeDocuGeneral = (path) => {
    const prefix = "10 Documentación general";
    return path.startsWith(prefix);
  };

  if (loading) {
    return (
      <div>
        <ClipLoader
          size={100}
          color={"#123abc"}
          loading={loading}
          cssOverride={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
          speedMultiplier={1}
        />
      </div>
    );
  }

  return (
    <div className="container-de-los-documentos">
      <div className="contenedor-ficheros-principal">
        <Dialogo
          inputValue={inputValue}
          setInputValue={setInputValue}
          inputElement={dialogoContenido.inputElement ? true : false}
          showDialog={showDialog}
          diagoloBody={dialogoContenido.cuerpo}
          diagoloTitulo={dialogoContenido.titulo}
          onConfirm={dialogoContenido.ejecutarFuncion}
          nombreCambiar={dialogoContenido.nombreCambiar}
          onClose={() => setShowDialog(false)}
        />

        <Modal show={showDialogModificar} onHide={handleCloseModificar} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {diccionario.CambiarNombreDe}
              {nombreCarpetaModificar}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>{diccionario.AnadirNombreCarpetaFichero}</Modal.Body>
          <div
            style={{
              display: "flex",
              flexWrap: "nowrap",
              justifyContent: "center",
              alignContent: "center",
              marginLeft: "100px",
              marginRight: "100px",
              marginBottom: "20px",
            }}
          >
            <form>
              <TextField
                value={inputValue} // Usa el valor del estado local
                onChange={handleInputChange}
                name="texto_"
                required
                inputProps={{
                  onKeyPress: validarCaracteresCarpeta,
                  onPaste: validarCaracteresCarpetaPaste,
                  maxLength: 35,
                  minLenght: 1,
                }}
                className="buscador"
                autoFocus
              />
              {nombreCarpetaModificar.includes(".") ? (
                <div
                  className="traspasble"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    margin: "0px",
                    marginTop: "10px",
                  }}
                >
                  <Tooltip content={"Este documento pertenece a la comunidad"}>
                    {" "}
                    <IoInformationCircleOutline
                      color="blue"
                      style={{
                        fontSize: "16px",
                        marginRight: "2px",
                        marginBottom: "2px",
                      }}
                    />
                  </Tooltip>

                  <p style={{ margin: "0px", marginRight: "10px" }}> Es transferible</p>
                  <div></div>
                  <Switch
                    checked={checkedTransferible}
                    onChange={toggleChecked}
                    onColor="#86d3ff"
                    onHandleColor="#2693e6"
                    handleDiameter={10}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={15}
                    width={28}
                  />
                  <p> {checkedTransferible ? diccionario.Si : diccionario.No}</p>
                </div>
              ) : null}
            </form>
          </div>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModificar}>
              {diccionario.cancelar}
            </Button>
            <Button
              variant="primary"
              onClick={(e) => handleModificar(e)}
              disabled={inputValue.length < 1}
            >
              {diccionario.aceptar}
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="contenedor-ficheros">
          {docusUsuario !== "true" && (
            <div className="nombreComu" style={{ marginTop: "10px", marginBottom: "25px" }}>
              <p style={{ margin: "0px", fontWeight: "bold", fontSize: "14px" }}>
                {" "}
                {Identificador === "documentaciongeneral"
                  ? diccionario.DocumentacionGeneral
                  : diccionario.DocumentosComunidad}
              </p>
              <span style={{ color: "blue", fontWeight: "400", fontSize: "16px" }}>
                {" "}
                {nombreComu}
              </span>
            </div>
          )}
          <input
            type="text"
            placeholder={diccionario.Busqueda}
            className="search-input"
            value={term}
            onChange={(e) => setTerm(e.target.value)}
          />
          <Tree
            renderCursor={Cursor}
            ref={treeRef}
            data={gData}
            width={280}
            height={540}
            onMove={onMove}
            onDrop={handleDrop}
            indent={30}
            rowHeight={32}
            searchTerm={term}
            openByDefault={false}
            selection={seleccionNuevaCarpeta ? seleccionNuevaCarpeta : null}
            searchMatch={(node, term) => node.data.name.toLowerCase().includes(term.toLowerCase())}
            childrenAccessor={(d) => d.folders}
          >
            {(props) => (
              <Node
                {...props}
                setArchivosEnCarpetaArborist={setArchivosEnCarpetaArborist}
                setSeleccionNuevaCarpeta={setSeleccionNuevaCarpeta}
                refrescarCarpetaNueva={refrescarCarpetaNueva}
                Identificador={Identificador}
                refrescar={refrescar}
                setRefrescar={setRefrescar}
                refresh={refresh}
                setLoading={setLoading}
              />
            )}
          </Tree>
        </div>
        {archivosEnCarpetaArborist.carpeta.length > 0 ? (
          <div
            className="contenedor-detalle-ficheros"
            onDrop={handleDrop}
            onDragOver={manejarArrastreEncima}
            onDragLeave={manejarArrastreFuera}
            style={{
              border: estaArrastrandoEncima ? "2px solid black" : "2px solid white",
              backgroundColor: estaArrastrandoEncima ? "#496af826" : "white",
              transition: "border 0.5s ease, background-color 0.5s ease",
            }}
          >
            <div className="container mt-4">
              <div className="aviso-fichero">
                <h4>
                  <RutaEnlaces ruta={archivosEnCarpetaArborist.path} />
                </h4>
              </div>
              <div>
                {!mostrarInput ? (
                  <div style={{ marginTop: "20px" }}>
                    <p style={{ fontWeight: "bold" }}>
                      {diccionario.CarpetaActual} &nbsp;
                      {(archivosEnCarpetaArborist.carpeta &&
                        archivosEnCarpetaArborist.carpeta == Identificador) ||
                      archivosEnCarpetaArborist.carpeta == Identificador + "/"
                        ? nombreEspecial
                        : archivosEnCarpetaArborist.carpeta === "10 Documentación general"
                        ? "Documentación general"
                        : archivosEnCarpetaArborist.carpeta}
                    </p>
                    <h5>
                      <button
                        type="button"
                        class="btn btn-outline-dark btn-sm mx-2"
                        /* disabled={
                          !archivosEnCarpetaArborist.archivos.some((element) =>
                            element.includes(".")
                          )
                        }*/
                        onClick={async () => {
                          await obtenerSoloPresi(archivosEnCarpetaArborist.path);
                          setPathAvisos(archivosEnCarpetaArborist.path);
                          modalEnvio();
                        }}
                      >
                        {diccionario.ENVIAR_AVISO}
                      </button>
                      <FaFolderPlus
                        cursor={"pointer"}
                        color="orange"
                        style={{ fontSize: "22px" }}
                        onClick={handleCarpeta}
                      />
                      {!(
                        docusUsuario &&
                        archivosEnCarpetaArborist.path.replace(/\/+$/, "") ===
                          `usuarios/${Identificador}`
                      ) &&
                      archivosEnCarpetaArborist.path !== Identificador + "/" &&
                      archivosEnCarpetaArborist.path !== Identificador ? (
                        <>
                          {archivosEnCarpetaArborist.path !== nombreDocumentacionGeneral &&
                            archivosEnCarpetaArborist.path !==
                              Identificador + "/" + nombreJuntasPropietarios && (
                              <FaFolderMinus
                                cursor={"pointer"}
                                color="red"
                                style={{ fontSize: "22px", marginLeft: "10px" }}
                                onClick={() =>
                                  handleMostrarDialogo(
                                    handleBorrarCarpeta,
                                    archivosEnCarpetaArborist.path,
                                    {
                                      titulo:
                                        diccionario.tituloConfirmarBorradoCarpeta +
                                        archivosEnCarpetaArborist.carpeta,
                                      cuperpomensaje: diccionario.textoConfirmarBorradoCarpeta,
                                    }
                                  )
                                }
                              />
                            )}
                          {archivosEnCarpetaArborist.path !== nombreDocumentacionGeneral &&
                            archivosEnCarpetaArborist.path !==
                              Identificador + "/" + nombreJuntasPropietarios && (
                              <LuFolderEdit
                                cursor={"pointer"}
                                color="green"
                                style={{ fontSize: "22px", marginLeft: "10px" }}
                                onClick={() => {
                                  handleMostrarDialogoCambiar(
                                    archivosEnCarpetaArborist.path,
                                    archivosEnCarpetaArborist.carpeta
                                  );
                                  setEsGeneral(true);
                                }}
                              />
                            )}
                        </>
                      ) : null}
                    </h5>
                  </div>
                ) : (
                  <div style={{ width: "340px", display: "flex" }}>
                    <TextField
                      value={nombreCarpeta}
                      onChange={handleChange}
                      placeholder={diccionario.NombreCarpeta}
                      type="text"
                      name="texto_"
                      required
                      inputProps={{
                        onKeyPress: validarCaracteresCarpeta,
                        onPaste: validarCaracteresCarpetaPaste,
                        maxLength: 35,
                        minLenght: 10,
                      }}
                      className="buscador"
                      autoFocus
                    />
                    <button
                      disabled={(!nombreCarpeta || nombreCarpeta.trim() === "") && true}
                      className="btn btn-outline-primary "
                      onClick={crearCosa}
                      style={{ marginLeft: "10px" }}
                    >
                      Guardar
                    </button>
                    <button
                      className="btn btn-outline-secondary "
                      onClick={() => {
                        setMostrarInput(false);
                        setNombreCarpeta("");
                      }}
                      style={{ marginLeft: "10px" }}
                    >
                      {diccionario.cancelar}
                    </button>
                  </div>
                )}
              </div>
              <hr />
              <ul className="list-group">
                {archivosEnCarpetaArborist.archivos.map((archivo, index) => {
                  const extension = archivo.includes(".")
                    ? archivo.split(".").pop().toLowerCase()
                    : "";
                  const icono = obtenerIconoPorExtension(extension);

                  let pathCarpeta = "";
                  if (archivo === nombreDocumentacionGeneral) {
                    pathCarpeta = archivo;
                  } else if (docusUsuario != "true") {
                    pathCarpeta =
                      archivosEnCarpetaArborist.firstLevel !== true
                        ? archivosEnCarpetaArborist.path + "/" + archivo
                        : Identificador + "/" + archivo;
                  } else {
                    pathCarpeta =
                      archivosEnCarpetaArborist.firstLevel !== true
                        ? archivosEnCarpetaArborist.path + "/" + archivo
                        : "usuarios/" + Identificador + "/" + archivo;
                  }
                  let rolesAsignados = [];

                  const pathSinComu = pathCarpeta.replace(/^[^/]*\//, "");

                  const partes = pathSinComu.split("/");

                  // Si estamos dentro de Documentacion general cambiamos de dónde se saca el dato dentro de soloPresi
                  let trozaco =
                    archivosEnCarpetaArborist.path.includes(nombreDocumentacionGeneral) &&
                    Identificador !== nombreDocumentacionGeneral
                      ? soloPresi[nombreDocumentacionGeneral]
                      : soloPresi;

                  partes.map((parte) => {
                    trozaco = trozaco ? trozaco[parte.toString()] : trozaco;
                  });
                  const result = [];
                  for (const key in trozaco) {
                    if (!Array.isArray(trozaco[key])) {
                      result[key] = trozaco[key];
                    }
                  }

                  rolesAsignados = Array.isArray(result) ? result : [];

                  let rolesTuneados = [];
                  rolesAsignados.map((valor) => {
                    rolesTuneados.push({
                      label: valor,
                      value: valor,
                      selected: true,
                    });
                  });
                  rolesAsignados = rolesTuneados;

                  const nombreElemento =
                    archivosEnCarpetaArborist.firstLevel !== true
                      ? archivo
                      : archivo.replace(/^[^/]*\//, "");

                  return (
                    <ol>
                      <li className="list-group-item" key={index}>
                        <div
                          className={`botono-icono ${extension === "" ? "carpato" : ""}`}
                          onClick={() => (extension === "" ? navegarPath(pathCarpeta) : null)}
                        >
                          {icono}

                          <Tooltip content={nombreElemento}>
                            {nombreElemento === "10 Documentación general"
                              ? "Documentación general"
                              : truncarCadena(nombreElemento, 25)}
                          </Tooltip>
                        </div>
                        <div className="botonacos">
                          {archivo !== nombreDocumentacionGeneral &&
                            archivo !== nombreJuntasPropietarios &&
                            !extension &&
                            docusUsuario != "true" && (
                              <MultiSelect
                                overrideStrings={locationSelector}
                                options={rolesOptions}
                                value={rolesAsignados}
                                onChange={(e) => asignarSoloPresi(e, pathCarpeta)}
                                labelledBy="Select"
                              />
                            )}
                          {archivo !== nombreDocumentacionGeneral &&
                            archivo !== nombreJuntasPropietarios &&
                            extension && (
                              <button
                                className="btn btn-outline-secondary btn-sm mx-2"
                                onClick={() =>
                                  handleDescargar(archivo, archivosEnCarpetaArborist.path, firebase)
                                }
                              >
                                {diccionario.Descargar}
                              </button>
                            )}
                          {archivo !== nombreDocumentacionGeneral &&
                            archivo !== nombreJuntasPropietarios && (
                              <button
                                className="btn btn-outline-primary btn-sm mx-2"
                                onClick={(e) => {
                                  handleMostrarDialogoCambiar(pathCarpeta, nombreElemento);
                                }}
                              >
                                {diccionario.modificar}
                              </button>
                            )}
                          {archivo !== nombreDocumentacionGeneral &&
                            archivo !== nombreJuntasPropietarios && (
                              <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => {
                                  const dentroDeDocumentacionGeneral =
                                    dentroDeDocuGeneral(pathCarpeta);
                                  if (extension !== "") {
                                    //handleBorrarFichero(pathBorrar);//
                                    handleMostrarDialogo(handleBorrarFichero, pathCarpeta, {
                                      titulo: diccionario.tituloConfirmarBorradoFichero + archivo,
                                      cuperpomensaje: !dentroDeDocumentacionGeneral
                                        ? diccionario.textoConfirmarBorradoFichero
                                        : diccionario.textoConfirmarBorradoFicheroGeneral,
                                    });
                                  } else {
                                    handleMostrarDialogo(handleBorrarCarpeta, pathCarpeta, {
                                      titulo: diccionario.tituloConfirmarBorradoCarpeta + archivo,
                                      cuperpomensaje: !dentroDeDocumentacionGeneral
                                        ? diccionario.textoConfirmarBorradoCarpeta
                                        : diccionario.textoConfirmarBorradoCarpetaGeneral,
                                    });
                                  }
                                }}
                              >
                                {diccionario.Borrar}
                              </button>
                            )}
                          <button
                            type="button"
                            className="btn btn-outline-dark btn-sm mx-2"
                            onClick={async () => {
                              if (extension !== "") {
                                setArchivoAvisos(archivo);
                                setPathAvisos(extraerAntesUltimaBarra(pathCarpeta));
                                // setRolesEnvios([]);
                                setRolesEnvios(rolesAsignados.map((rol) => rol.value));
                                modalEnvio();
                              } else {
                                /*
                                await obtenerSoloPresi(
                                  extraerAntesUltimaBarra(pathCarpeta)
                                );*/
                                setRolesEnvios(rolesAsignados.map((rol) => rol.value));
                                setPathAvisos(pathCarpeta);
                                modalEnvio();
                                //setRolesEnvios([]);
                              }
                            }}
                          >
                            {diccionario.EnviarAviso}
                          </button>
                        </div>
                      </li>
                    </ol>
                  );
                })}
              </ul>
              <div
                className="drop-area"
                onClick={handleClick}
                style={{
                  borderRadius: "5px",
                  height: "200px",
                  width: "460px",
                  margin: "50px auto",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="96"
                  height="96"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#3498db"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{ marginBottom: "16px" }}
                >
                  <rect x="2" y="2" width="20" height="20" rx="2" ry="2" />
                  <line x1="12" y1="8" x2="12" y2="16" />
                  <line x1="8" y1="12" x2="16" y2="12" />
                </svg>

                <p style={{ fontSize: "16px", color: "#555" }}>
                  {diccionario.ArrastraSueltaArchivosSubirlosCarpeta} <br />
                  <strong>
                    {archivosEnCarpetaArborist.carpeta === Identificador + "/" ||
                    archivosEnCarpetaArborist.carpeta === Identificador
                      ? "Raíz"
                      : archivosEnCarpetaArborist.carpeta === "10 Documentación general"
                      ? "Documentación general"
                      : archivosEnCarpetaArborist.carpeta}
                  </strong>
                </p>
                <i style={{ color: "red" }}>* {diccionario.AvisoDocumentosSubidosC365}</i>
              </div>
            </div>
          </div>
        ) : (
          <h5>{diccionario.SeleccionarCarpetaMostrarDetalle}</h5>
        )}

        <Emulador
          archivosEnCarpetaArborist={archivosEnCarpetaArborist}
          Identificador={Identificador}
          docusUsuario={docusUsuario}
        />
      </div>
      <div
        className="row form-actions-fixed"
        id="footerInsert"
        style={{ background: "transparent" }}
      >
        <div
          className="text-left px-0 col-1"
          id="footerInsertVolver"
          style={{ marginBottom: "10px" }}
        >
          <BackButton />
        </div>{" "}
      </div>

      <ModalComponent
        top={"40%"}
        alturaCustom={"50%"}
        tituloModal={diccionario.ENVIAR_AVISO_DOCUMENTOS}
        cuerpoModal={
          <FormularioEnvioAvisos
            comunidadesSeleccionadas={
              docusUsuario === "true" ? [{ Id: IdComu }] : [{ Id: Identificador }]
            }
            usuariosSeleccionados={docusUsuario === "true" ? usuario : []}
            roles={rolesEnvios}
            abrirDiagolo={abrirDiagolo}
            cerrarDiagolo={() => setModalOpen(false)}
            archivo={archivoAvisos}
            pathCarpeta={pathAvisos}
          />
        }
        isModalOpen={isModalOpen}
        setModalOpen={setModalOpen}
        closeEnvios={true}
      />
    </div>
  );
};

export default Documentos;
